import Image from "@components/Image";
import cx from "classnames";
import styles from "./FeaturedItem.module.scss";
// import { usePageContext } from "@providers/PageProvider";
// import { brandStoryPage } from "@utils/helper";
import _ from "lodash";

export default function FeaturedItem({ data }: any) {
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.brief)}>
        <div className={cx(styles.content)}>{_.get(data, "content", "")}</div>
        <div className={cx(styles.quote)}>{_.get(data, "quote", "")}</div>
      </div>
      <div className={cx(styles.imageWrapper)}>
        <Image
          wrapperProps={{ className: cx(styles.image) }}
          src={_.get(data, "image.src", {})}
          alt={_.get(data, "image.alt", {})}
          layout="fill"
          objectFit="cover"
        />
        <div className={cx(styles.textContent)}>
          <div className={cx(styles.smallText)}>
            {_.get(data, "bottomQuote", "")}
          </div>
          {_.get(data, "bottomContent", "")}
        </div>
      </div>
    </div>
  );
}
